import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  NgZone,
} from '@angular/core';
import { ILocationAddress, ISearchCriteria } from '../../interfaces/search-criteria';
import { InboxJobsService } from '../../services/inbox-jobs.service';
import { MapService } from '../../services/map.service';
import { BBWTMessageService } from '../../services/message.service';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { SearchCriteriaService } from '../../services/search-criteria.service';
import { SupplierInboxJobsService } from '../../services/supplier-inbox-jobs.service';
import { TaskService } from '../../services/task.service';
import moment from 'moment';

@Component({
  selector: 'ad-hoc-search',
  templateUrl: './ad-hoc-search.component.html',
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class AdHocSearchComponent implements OnInit {
  public isBusy: boolean = false;
  public id: number;
  public searchCriteriaForm: UntypedFormGroup;
  public searchCriteriaForms: any;
  public items: any[] = [];
  public selectedJob: any;
  public useSortColumns = false; //this flag is used for a case if we decide to use sorting then
  public searchCriteriaToSave: ISearchCriteria = null;

  @ViewChild('pickupLocationRef')
  public pickupLocationRef: ElementRef;
  @ViewChild('dropoffLocationRef')
  public dropoffLocationRef: ElementRef;

  public _pickupLocation: string;
  @Output() pickupLocationChange: EventEmitter<string>;
  @Input('pickupLocation')
  public set pickupLocation(value: string) {
    this._pickupLocation = value;
    this.pickupLocationChange.emit(value);
  }
  public get pickupLocation(): string {
    return this._pickupLocation;
  }

  public _dropoffLocation: string;
  @Output() dropoffLocationChange: EventEmitter<string>;
  @Input('dropoffLocation')
  public set dropoffLocation(value: string) {
    this._dropoffLocation = value;
    this.dropoffLocationChange.emit(value);
  }
  public get dropoffLocation(): string {
    return this._dropoffLocation;
  }

  private _fromLocation: ILocationAddress = null;
  @Output() fromLocationChange: EventEmitter<ILocationAddress>;
  @Input('fromLocation')
  public set fromLocation(value: ILocationAddress) {
    this._fromLocation = value;
    if (this._fromLocation && !this._fromLocation.location) {
      this.LoadAddress('', '', '', '', this._fromLocation.latitude, this._fromLocation.longitude)
        .then((x) => {
          var address = this.GetNormalAddress(x.formatted_address);
          this._fromLocation.location = address;
          this.pickupLocation = address;
        })
        .catch((ex) => {
          this.fromLocation = null;
          this.pickupLocation = '';
          this.UpdateMapPoint();
        });
    }
    this.UpdateMapPoint();
    this.fromLocationChange.emit(value);
  }
  public get fromLocation(): ILocationAddress {
    return this._fromLocation;
  }

  private _toLocation: ILocationAddress = null;
  @Output() toLocationChange: EventEmitter<ILocationAddress>;
  @Input('toLocation')
  public set toLocation(value: ILocationAddress) {
    this._toLocation = value;
    if (this._toLocation && !this._toLocation.location) {
      this.LoadAddress('', '', '', '', this._toLocation.latitude, this._toLocation.longitude)
        .then((x) => {
          var address = this.GetNormalAddress(x.formatted_address);
          this._toLocation.location = address;
          this.dropoffLocation = address;
        })
        .catch((ex) => {
          this.toLocation = null;
          this.dropoffLocation = '';
          this.UpdateMapPoint();
        });
    }
    this.UpdateMapPoint();
    this.toLocationChange.emit(value);
  }
  public get toLocation(): ILocationAddress {
    return this._toLocation;
  }

  public _pickupDistance: number;
  @Output() pickupDistanceChange: EventEmitter<number>;
  @Input('pickupDistance')
  public set pickupDistance(value: number) {
    this._pickupDistance = value;
    this.UpdateMapPoint();
    this.pickupDistanceChange.emit(value);
  }
  public get pickupDistance(): number {
    return this._pickupDistance;
  }

  public _dropoffDistance: number;
  @Output() dropoffDistanceChange: EventEmitter<number>;
  @Input('dropoffDistance')
  public set dropoffDistance(value: number) {
    this._dropoffDistance = value;
    this.UpdateMapPoint();
    this.dropoffDistanceChange.emit(value);
  }
  public get dropoffDistance(): number {
    return this._dropoffDistance;
  }

  public _pickUpFrom: Date;
  @Output() pickUpFromChange: EventEmitter<Date>;
  @Input('pickUpFrom')
  public set pickUpFrom(value: Date) {
    if (value) {
      value.setSeconds(0);
      value.setMilliseconds(0);
    }
    this._pickUpFrom = value;
    this.pickUpFromChange.emit(value);
  }
  public get pickUpFrom(): Date {
    return this._pickUpFrom;
  }

  public _pickUpTo: Date;
  @Output() pickUpToChange: EventEmitter<Date>;
  @Input('pickUpTo')
  public set pickUpTo(value: Date) {
    if (value) {
      value.setSeconds(0);
      value.setMilliseconds(0);
    }
    this._pickUpTo = value;
    this.pickUpToChange.emit(value);
  }
  public get pickUpTo(): Date {
    return this._pickUpTo;
  }

  public locationPoins: Array<any> = [];

  constructor(
    private searchCriteriaService: SearchCriteriaService,
    private route: ActivatedRoute,
    private router: Router,
    public messageService: BBWTMessageService,
    private formBuilder: UntypedFormBuilder,
    private mapService: MapService,
    private taskService: TaskService,
    private mapsAPILoader: MapsAPILoader,
    private inboxjobsService: InboxJobsService,
    private ngZone: NgZone,
    private supplierInboxjobsService: SupplierInboxJobsService,
  ) {
    this.pickupLocationChange = new EventEmitter<string>();
    this.dropoffLocationChange = new EventEmitter<string>();
    this.pickupDistanceChange = new EventEmitter<number>();
    this.dropoffDistanceChange = new EventEmitter<number>();
    this.pickUpFromChange = new EventEmitter<Date>();
    this.pickUpToChange = new EventEmitter<Date>();
    this.fromLocationChange = new EventEmitter<ILocationAddress>();
    this.toLocationChange = new EventEmitter<ILocationAddress>();
  }

  ngOnInit() {
    this.searchCriteriaForms = {
      pickupLocation: new UntypedFormControl('', Validators.compose([Validators.maxLength(35)])),
      dropoffLocation: new UntypedFormControl('', Validators.compose([Validators.maxLength(35)])),
      pickupDistance: new UntypedFormControl(null),
      dropoffDistance: new UntypedFormControl(null),
      pickUpFrom: new UntypedFormControl('', (validator: UntypedFormControl) => {
        if (!validator.parent) return null;

        let pickUpTo = validator.parent.controls['pickUpTo'];

        if (this.dateIsValid(pickUpTo.value)) {
          pickUpTo.setValue(pickUpTo.value);
        }

        return null;
      }),
      pickUpTo: new UntypedFormControl('', (validator: UntypedFormControl) => {
        if (!validator.parent) return null;

        let pickUpFrom = validator.parent.controls['pickUpFrom'];

        if (pickUpFrom.value && validator.value <= pickUpFrom.value) {
          validator.markAsDirty();
          return { valid: false, error: 'This value must be greater than Pick-up From' };
        }

        return null;
      }),
    };

    this.searchCriteriaForm = this.formBuilder.group({
      id: 0,
      pickupLocation: this.searchCriteriaForms.pickupLocation,
      dropoffLocation: this.searchCriteriaForms.dropoffLocation,
      pickupDistance: this.searchCriteriaForms.pickupDistance,
      dropoffDistance: this.searchCriteriaForms.dropoffDistance,
      pickUpFrom: this.searchCriteriaForms.pickUpFrom,
      pickUpTo: this.searchCriteriaForms.pickUpTo,
    });

    this.mapsAPILoader.load().then(() => {
      let autocompletePickup = new google.maps.places.Autocomplete(
        this.pickupLocationRef.nativeElement,
        {
          //types: ["address", "(cities)"],
          types: ['(regions)'],
          componentRestrictions: { country: 'uk' },
        },
      );
      let autocompleteDropoff = new google.maps.places.Autocomplete(
        this.dropoffLocationRef.nativeElement,
        {
          types: ['(regions)'],
          componentRestrictions: { country: 'uk' },
        },
      );
      autocompletePickup.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          let place = autocompletePickup.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          var address = this.GetNormalAddress(place.formatted_address);

          this.fromLocation = {
            id: 0,
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            location: address,
          };

          this.pickupLocation = address;
        });
      });

      autocompleteDropoff.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          let place = autocompleteDropoff.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          var address = this.GetNormalAddress(place.formatted_address);

          this.toLocation = {
            id: 0,
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            location: address,
          };

          this.dropoffLocation = address;
        });
      });
    });

    //Set Default Pick Up Dates
    this.InitDefaultValues();

    this.route.params.subscribe((params: Params) => {
      var from = {
        id: 0,
        latitude: parseFloat(params['pickupLat']),
        longitude: parseFloat(params['pickupLon']),
        location: '',
      };

      var to = {
        id: 0,
        latitude: parseFloat(params['dropoffLat']),
        longitude: parseFloat(params['dropoffLon']),
        location: '',
      };

      if (from.latitude && from.longitude) this.fromLocation = from;

      if (to.latitude && to.longitude) this.toLocation = to;

      this.UpdateMapPoint();
    });
  }

  dateIsValid(d): boolean {
    return d && !isNaN(d.valueOf());
  }

  formIsValid() {
    return (
      this.searchCriteriaForm.valid &&
      (this.fromLocation != null || this.toLocation != null) &&
      !(this.fromLocation != null && !this.pickupDistance) &&
      !(this.toLocation != null && !this.dropoffDistance)
    );
  }

  GetNormalAddress(address) {
    while (address.length > 35) {
      var index = address.lastIndexOf(',');
      address = address.slice(0, index);
    }

    return address;
  }

  tasksCountPostfix(item, value) {
    if (value == null || value == '' || item.tasksCount < 2) return value;
    return value + ' (+' + (item.tasksCount - 1) + ')';
  }

  InitDefaultValues() {
    this.pickUpFrom = new Date();
    this.pickUpFrom.setHours(0, 0, 0, 0);

    this.pickUpTo = new Date();
    this.pickUpTo.setDate(this.pickUpFrom.getDate() + 1);
    this.pickUpTo.setHours(0, 0, 0, 0);
  }

  UpdateMapPoint() {
    this.locationPoins = [];
    if (this.fromLocation != null && this.pickupDistance != null && this.pickupDistance > 0) {
      this.locationPoins.push({
        longitude: this.fromLocation.longitude,
        latitude: this.fromLocation.latitude,
        label: 'From',
        radius: this.pickupDistance * 1609.34,
        color: 'red',
      });
    }

    if (this.toLocation != null && this.dropoffDistance != null && this.dropoffDistance > 0) {
      this.locationPoins.push({
        longitude: this.toLocation.longitude,
        latitude: this.toLocation.latitude,
        label: 'To',
        radius: this.dropoffDistance * 1609.34,
        color: 'green',
      });
    }
    this.isBusy = false;
  }

  LoadAddress(
    primary: string,
    city: string,
    postalcode: string,
    country: string,
    lat: number,
    lng: number,
  ): Promise<any> {
    if (lat && lng) {
      return this.mapService.GetAddressFromCoord(lat, lng); //address.push(lat, lng)
    }

    var address = [];
    if (primary) {
      address.push(primary);
    }

    if (city) {
      address.push(city);
    }

    if (postalcode) {
      address.push(postalcode);
    }

    if (country) {
      address.push(country);
    }

    return this.mapService.GetAddress(address.join());
  }

  close() {
    window.history.back();
  }

  search() {
    if (
      (this.fromLocation == null || !this.pickupDistance) &&
      (this.toLocation == null || !this.dropoffDistance)
    ) {
      return;
    }
    this.isBusy = true;
    var searchCriteria: ISearchCriteria = {
      id: 0,
      organisationId: 0,
      fromLocation: this.fromLocation,
      fromRadius: this.pickupDistance,
      pickUpFrom: this.pickUpFrom,
      pickUpTo: this.pickUpTo,
      toLocation: this.toLocation,
      toRadius: this.dropoffDistance,
      created: new Date(),
    };

    if (searchCriteria.fromLocation) searchCriteria.fromLocation.id = 0;
    if (searchCriteria.toLocation) searchCriteria.toLocation.id = 0;

    this.searchCriteriaService
      .getInboxJobs(searchCriteria)
      .then((x) => {
        this.items = x;
        this.isBusy = false;
        this.searchCriteriaToSave = searchCriteria;

        document.getElementById('dtResult').scrollIntoView();
      })
      .catch((x) => {
        this.isBusy = false;
      });
  }

  public inputErrorToShow(c: any): string {
    return !c.valid && c.dirty && c._errors && c._errors.error ? c._errors.error : null;
  }

  editJob(item) {
    this.router.navigate(['app/jobscreen/' + item.id]);
  }

  watchJob(item) {
    this.supplierInboxjobsService.watchJob(item.id).then(() => {
      this.messageService.ShowSuccess('Watch Job', 'Job is watched');
    });
  }
}
